import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import type { ApiErrorHandler } from './handleApiError';

/**
 * Construye el `QueryClient` global con `onError` centralizado. La política
 * de 401 vive en `handleApiError` — acá sólo se cablean los caches.
 *
 * `retry: false` por defecto: los errores se propagan rápido al usuario;
 * los reintentos serios viven en el WebSocket (backoff 5×) o en lógica
 * de aplicación específica.
 */
export function createQueryClient(onError: ApiErrorHandler): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({ onError }),
    mutationCache: new MutationCache({ onError }),
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
